import React from 'react';
import { Modal, Input, Spin } from 'antd';
import { SearchOutlined, UserOutlined, CheckCircleFilled } from '@ant-design/icons';
import { Button } from '@/components/ui/Button';
import { colors, rgbaFromHex } from '@/utils/colorSystem';

export default function ClientSelectModal({
    open,
    onCancel,
    clientSearch,
    setClientSearch,
    clientsLoading,
    filteredClients,
    tempClientId,
    setTempClientId,
    handleClientModalSave
}) {
    return (
        <Modal
            title="Select Project Client"
            open={open}
            onCancel={onCancel}
            footer={null}
            width={650}
            centered
            styles={{ body: { paddingTop: 20 } }}
        >
            <div style={{ marginBottom: 16 }}>
                <Input 
                    placeholder="Search clients by name or email..." 
                    prefix={<SearchOutlined style={{ color: colors.neutral[400] }} />}
                    value={clientSearch}
                    onChange={(e) => setClientSearch(e.target.value)}
                    allowClear
                    style={{ height: 40, borderRadius: 8 }}
                />
            </div>
            {clientsLoading ? (
                <div style={{ padding: 40, textAlign: 'center' }}><Spin size="large" /></div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxHeight: '50vh', overflowY: 'auto', paddingRight: 4 }}>
                    {filteredClients.map(c => {
                        const isSelected = tempClientId === c.id;
                        return (
                            <div 
                                key={c.id}
                                onClick={() => setTempClientId(c.id)}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '14px 18px',
                                    borderRadius: 12,
                                    border: `1px solid ${isSelected ? colors.primary[600] : colors.neutral[200]}`,
                                    background: isSelected ? colors.primary[50] : '#fff',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease-in-out',
                                    boxShadow: isSelected ? `0 2px 8px ${rgbaFromHex(colors.primary[600], 0.08)}` : 'none'
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{ 
                                        width: 36, 
                                        height: 36, 
                                        borderRadius: '50%', 
                                        background: isSelected ? '#fff' : colors.neutral[50], 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center', 
                                        border: `1px solid ${isSelected ? colors.primary[100] : colors.neutral[100]}`,
                                        flexShrink: 0
                                    }}>
                                        <UserOutlined style={{ color: isSelected ? colors.primary[600] : colors.neutral[400] }} />
                                    </div>
                                    <div>
                                        <div style={{ fontWeight: 600, fontSize: 13, color: colors.neutral[900] }}>{c.name || 'Unnamed Client'}</div>
                                        {c.email && <div style={{ fontSize: 11, color: colors.neutral[400], marginTop: 1 }}>{c.email}</div>}
                                    </div>
                                </div>
                                {isSelected && <CheckCircleFilled style={{ color: colors.primary[600], fontSize: 18 }} />}
                            </div>
                        );
                    })}
                    {filteredClients.length === 0 && (
                        <div style={{ padding: 24, textAlign: 'center', color: colors.neutral[400] }}>No clients found matching search.</div>
                    )}
                </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 24, borderTop: `1px solid ${colors.neutral[100]}`, paddingTop: 16 }}>
                <Button 
                    onClick={onCancel} 
                    style={{ background: '#fff', border: `1px solid ${colors.neutral[200]}`, borderRadius: 8, padding: '0 20px', height: 38, fontWeight: 500 }}
                >
                    Cancel
                </Button>
                <Button 
                    $primary 
                    $blackOnLight 
                    onClick={handleClientModalSave}
                    style={{ borderRadius: 8, padding: '0 24px', height: 38, fontWeight: 600 }}
                >
                    Save Client
                </Button>
            </div>
        </Modal>
    );
}
